export default __webpack_public_path__ + "static/media/pack4d.e4037b14.png";